// ----- Base
import "../../../../js/base";
import "../../../../js/atoms/toggle/translate-contents";
import "../../../../js/molecules/course-navigation/course-navigation-new";
import "../../../../js/molecules/popover/teacher-popover";
import "../../../../js/molecules/footer/promo-footer";
import "../../../../js/molecules/countdown/countdown";
import "../../../../js/molecules/popover/sharing-buttons-popover";
import "../../../../js/molecules/promo-header/promo-header-new";
import "../../../../js/organism/sidebar/sidebarCourse";
import "../../../../js/organism/shareButton/events";
import "../../../../js/molecules/popover/events";
import "../../../../js/molecules/fields/copyToClipboardField";

import { Application } from "@hotwired/stimulus";
import BuyOptionsController from "../../../ds/buy_options_controller";
import MatchHeightController from "../../../../js/controllers/match_height_controller";
import DsPortletOptionsController from "../../../ds/portletOptions/portlet_options_controller";
import DsSectionNavigation from "../../../ds/section_navigation_controller";
import MentoredController from "../../../ds/mentored_controller";
import GroupController from "../../../ds/group_controller";

window.Stimulus = Application.start();
window.Stimulus.register("buy-options", BuyOptionsController);
window.Stimulus.register("match-height", MatchHeightController);
window.Stimulus.register("ds-portlet-options", DsPortletOptionsController);
window.Stimulus.register("ds-section-navigation", DsSectionNavigation);
window.Stimulus.register("mentored", MentoredController);
window.Stimulus.register("group", GroupController);

Domestika.courses_controller.show_new();
